import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/virock ebook mockup.webp")